import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ApiResponse } from '../interfaces/api.interface';
import { Company, ICompany } from '../models/company.model';

@Injectable({
  providedIn: 'root'
})
export class AdminCompaniesService {
  private baseUrl = '/api/companies';
  
  constructor(private http: HttpClient) {}
  
  /**
   * Get all companies for autocomplete
   */
  getCompanies(search?: string): Observable<ApiResponse<Company[]>> {
    let params = new HttpParams();
    
    if (search) {
      params = params.set('search', search);
    }
    
    return this.http.get<ApiResponse<ICompany[]>>(this.baseUrl, { params }).pipe(
      map(response => ({
        ...response,
        data: response.data?.map((company: ICompany) => new Company(company)) || []
      }))
    );
  }
  
  /**
   * Get company by ID
   */
  getCompanyById(id: number): Observable<ApiResponse<Company | null>> {
    return this.http.get<ApiResponse<ICompany>>(`${this.baseUrl}/${id}`).pipe(
      map(response => ({
        ...response,
        data: response.data ? new Company(response.data) : null
      }))
    );
  }
  
  /**
   * Search companies for autocomplete
   */
  searchCompanies(query: string): Observable<Company[]> {
    const params = new HttpParams().set('search', query).set('limit', '20');
    
    return this.http.get<ApiResponse<ICompany[]>>(this.baseUrl, { params }).pipe(
      map(response => response.data?.map((company: ICompany) => new Company(company)) || [])
    );
  }
}
